import { Input, type InputProps } from '@chakra-ui/react';
import { forwardRef } from 'react';

/**
 * An input for decimal percentages between 0 and 1 (e.g. 0.25 for 25%).
 */
export const DecimalPercentInput = forwardRef<HTMLInputElement, InputProps>(
  (props, ref) => {
    return (
      <Input
        ref={ref}
        {...props}
        type="number"
        inputMode="decimal"
        step="0.01"
        min={0}
        max={1}
      />
    );
  },
);

DecimalPercentInput.displayName = 'DecimalPercentInput';
